import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Locale } from '../../../../shared/model/locale.model';
import { ControlContainer, FormControl, FormGroup, NgForm, UntypedFormGroup } from '@angular/forms';
import { Group, Product } from '../../../../shared/model/product.model';
import { TranslateService } from '@ngx-translate/core';
import { ColorService } from '../../../../shared/services/color.service';
import { ProductsService } from '../../../../shared/services/products.service';
import { ProductStub } from '../../../../shared/model/product-stub.model';

@Component({
  selector: 'app-product-grouped-offer-hours',
  templateUrl: './product-grouped-offer-hours.component.html',
  styleUrls: ['./product-grouped-offer-hours.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ProductGroupedOfferHoursComponent implements OnInit, OnChanges {
  @Input() mode: string;
  @Input() locale: Locale;
  @Input() frm: FormGroup;
  @Input() product!: Product | ProductStub;

  offerGroups: Group[] = null;

  constructor(
    private translate: TranslateService,
    private colorService: ColorService,
    private productService: ProductsService,
  ) {}

  ngOnInit() {
    this.productService.product$.subscribe((product) => {
      console.log('ProductGroupedOfferHoursComponent.productService.product$ subscription', product);
      this.product = product;
      this.loadOfferGroups();
    });
  }

  ngOnChanges(): void {
    console.log('ProductGroupedOfferHoursComponent.ngOnChanges', this.frm, this.mode, this.locale);
    this.loadOfferGroups();
  }

  private timeStringToMinutes(time: string): number {
    if (!time) return 0;
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  get blueButtonForm(): UntypedFormGroup {
    return this.frm as UntypedFormGroup;
  }

  loadOfferGroups(): void {
    if (!(this.product instanceof ProductStub)) {
      this.product?.operationalHours?.forEach((group) => {
        console.log('Loading offer group:', group);

        const convertedIntervals =
          group.intervals?.map((interval) => ({
            ...interval,
            id: this.generateIntervalId(),
            start: this.timeStringToMinutes(interval.startTm),
            end: this.timeStringToMinutes(interval.endTm),
          })) || [];

        if (!this.offerGroups) {
          this.offerGroups = [];
        }

        this.offerGroups.push({
          ...group,
          id: this.generateGroupId(),
          intervals: convertedIntervals,
          color: this.colorService.getNextColor(this.offerGroups.length),
        });
      });
    }
  }

  private generateGroupId(): string {
    return `group-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  private generateIntervalId(): string {
    return `interval-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  onGroupsChanged(groups: Group[]): void {
    // Aggiorna lo stato locale quando cambia qualcosa
    console.log('Groups changed:', groups);

    console.log('Updating form control operationalHours with new groups');
    if (!(this.product instanceof ProductStub)) {
      this.product.operationalHours = groups;
    }
    console.log('Updating form', this.frm.value);
  }

  get isEditMode() {
    return this.mode === 'edit';
  }

  get isCreateMode() {
    return this.mode === 'create';
  }

  get isViewMode() {
    return this.mode === 'view';
  }
}
